import { Tag } from "components/miloDesignSystem/atoms/tag";
import { Typography } from "components/miloDesignSystem/atoms/typography";
import { TypographyProps } from "components/miloDesignSystem/atoms/typography/types";
import { parseISO } from "date-fns";
import { calculateDaysDifference, getStandardDateFormat } from "utilities";
import { EmptyValue } from "utilities/tableColumnsUtilities/createTableColumns/createTableColumns";

interface Props {
  fontSize: TypographyProps["fontSize"];
  fontWeight: TypographyProps["fontWeight"];
  estimatedDelivery: string | null;
}

export const EstimatedDelivery = ({ estimatedDelivery, fontSize, fontWeight }: Props) => {
  if (!estimatedDelivery) return <EmptyValue fontSize={fontSize} fontWeight={fontWeight} />;

  const daysDifference = calculateDaysDifference(parseISO(estimatedDelivery));

  if (daysDifference < -3) {
    return <Tag label={getStandardDateFormat(estimatedDelivery)} variant="danger" />;
  }

  if (daysDifference >= -3 && daysDifference < -1) {
    return (
      <div className="d-flex align-items-center gap-1">
        <Tag label={getStandardDateFormat(estimatedDelivery)} variant="danger" />
        <Typography color="danger500" fontSize={fontSize} fontWeight={fontWeight}>
          {daysDifference} dni temu
        </Typography>
      </div>
    );
  }

  if (daysDifference >= -1 && daysDifference <= 1) {
    return (
      <div className="d-flex align-items-center gap-1">
        <Tag
          label={getStandardDateFormat(estimatedDelivery)}
          variant={daysDifference === -1 || daysDifference === 0 ? "danger" : "warning"}
        />
        <Typography
          color={daysDifference === -1 || daysDifference === 0 ? "danger500" : "warning500"}
          fontSize={fontSize}
          fontWeight={fontWeight}
        >
          {daysDifference === -1 ? "wczoraj" : daysDifference === 0 ? "dzisiaj" : "jutro"}
        </Typography>
      </div>
    );
  }

  if (daysDifference > 1 && daysDifference <= 3) {
    return (
      <div className="d-flex align-items-center gap-1">
        <Tag label={getStandardDateFormat(estimatedDelivery)} variant="warning" />
        <Typography color="warning500" fontSize={fontSize} fontWeight={fontWeight}>
          pozostało {daysDifference} dni
        </Typography>
      </div>
    );
  }

  if (daysDifference > 3) {
    return <Tag label={getStandardDateFormat(estimatedDelivery)} variant="success" />;
  }

  return null;
};
